var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnchecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6672_33081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7477 10.4427L1.55766 1.25266L0.847656 1.95766L1.98266 3.09266C1.45766 3.88266 1.15266 4.82766 1.15266 5.84766C1.15266 8.60766 3.39266 10.8477 6.15266 10.8477C7.17266 10.8477 8.11766 10.5427 8.90766 10.0177L10.0427 11.1527L10.7477 10.4427ZM5.44766 8.14766L3.32766 6.02766L4.03266 5.32266L5.44766 6.73766L5.53766 6.64766L6.24266 7.35266L5.44766 8.14766ZM6.94766 5.22766L3.39766 1.67766C4.18766 1.15266 5.13266 0.847656 6.15266 0.847656C8.91266 0.847656 11.1527 3.08766 11.1527 5.84766C11.1527 6.86766 10.8477 7.81266 10.3227 8.60266L7.65266 5.93266L8.97766 4.60766L8.27266 3.90266L6.94766 5.22766Z",
    fill: "#D64309"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6672_33081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchecked);
export default __webpack_public_path__ + "static/media/unchecked.84c652d0caae8f760363716fabebd93a.svg";
export { ForwardRef as ReactComponent };